"use strict";
/**
 * params.js
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ciphers = {
    'AES-GCM': {
        nodePrefix: 'aes-',
        nodeSuffix: '-gcm',
        ivLength: 12,
        tagLength: 16,
        staticIvLength: true, // if true, IV length must be always ivLength.
    },
    'AES-CBC': {
        nodePrefix: 'aes-',
        nodeSuffix: '-cbc',
        ivLength: 16,
        staticIvLength: true,
    },
    'AES-CTR': {
        nodePrefix: 'aes-',
        nodeSuffix: '-ctr',
        ivLength: 12,
        staticIvLength: false,
    }
};
var wrapKeys = {
    'AES-KW': {
        nodePrefix: 'id-aes',
        nodeSuffix: '-wrap',
        ivLength: 8,
        staticIvLength: true,
        defaultIv: new Uint8Array([0xA6, 0xA6, 0xA6, 0xA6, 0xA6, 0xA6, 0xA6, 0xA6])
    }
};
exports.default = { ciphers: ciphers, wrapKeys: wrapKeys };
//# sourceMappingURL=params.js.map